import { useContext } from 'react';

import { RecurringExamEventCreationContext } from './recurring-exam-event-creation-provider';

function useRecurringExamEventCreation() {
  const context = useContext(RecurringExamEventCreationContext);
  if (!context) {
    throw new Error(
      'useRecurringExamEventCreation must be used within a RecurringExamEventCreationProvider',
    );
  }

  return context;
}

export { useRecurringExamEventCreation };
